import type { GridColDef } from "@mui/x-data-grid";
import { useMemo } from "react";

import { columnDataGridSettings } from "~/constants/columnDataGridSettings";
import { marketColumnSizing } from "~/feature/event/components/MarketsDataGrid/marketColumnWidth";
import {
  MARKETS_DATA_GRID_FIELDS,
  marketsDataGridCellByField,
} from "~/feature/event/components/MarketsDataGrid/marketsDataGridCells";
import {
  type IMarketsDataGridRow,
  MarketsDataGridField,
} from "~/feature/event/components/MarketsDataGrid/types";
import type { IAggregatedEvent } from "~/types/event";

interface IUseMarketsDataGridColumnsProps {
  event: IAggregatedEvent;
}

const columnOverridesByField: Partial<
  Record<MarketsDataGridField, Partial<GridColDef<IMarketsDataGridRow>>>
> = {
  [MarketsDataGridField.Market]: { align: "left" },
  [MarketsDataGridField.Trade]: { sortable: false },
};

export const useMarketsDataGridColumns = ({
  event,
}: IUseMarketsDataGridColumnsProps) => {
  const columns = useMemo<GridColDef<IMarketsDataGridRow>[]>(
    () =>
      MARKETS_DATA_GRID_FIELDS.map((field) => ({
        ...columnDataGridSettings,
        ...marketColumnSizing[field],
        field,
        ...columnOverridesByField[field],
        renderCell: ({ row }) => marketsDataGridCellByField[field](row, event),
      })),
    [event]
  );

  return { columns };
};
